import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import TransportPage from '../../views/TransportPage/';

class Editroute extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			_message : '',
			alertClass :'',
			id : '',
			vno : '',
			rcode : '',
			startplace : '',
			stopplace : '',
			posts : [],
			vehi : [],
			 _redirect : false,
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	onBack(e){
		
		this.setState({_redirect : true});
	}
	
	/** set value **/
	onChange(e){
		
		this.setState({[e.target.name]:e.target.value});
		// console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.vno && this.state.rcode && this.state.startplace && this.state.stopplace){
			$("#showLoader").show();
			console.log(this.state);
			PostData('transport/updateroute',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Route Updated Successfullly',
						alertClass:'alert alert-success'
					});	
					document.getElementById("edrouform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	componentWillMount(){
		
		this.getdetails();
		this.getvehicleno();
	}
	
	getdetails(){
		$("#showLoader").show();
		GetData('transport/getroutebyid/'+this.props.match.params.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					vno : res[0]['vehicleno'],
					rcode : res[0]['routecode'],
					startplace: res[0]['startplace'],
					stopplace : res[0]['stopplace']
				});
			}
		});
	}
	
	/** get Department **/
	getvehicleno(){
		
		GetData('transport/getvehicle').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					vehi : responseJson
				});
			}
		});
	}
	
  render() {
	  
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/transport/transroute' />);
	}
	
	var veh = this.state.vehi;
	
    return (
		<div>
		  <TransportPage />
			<div className="animated fadeIn">
				<Row>
				  <Col md="6">
					<Card>
					  <form action="" method="post" id="edrouform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Edit Route</strong>
							<span className="pull-right">
								<Button outline color="primary" onClick={this.onBack}>Back</Button>
							</span>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<div className={this.state.alertClass}>
									{this.state._message}
								</div>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Vehicle No <span className="text-danger">*</span></Label>
								  <select name="vno" onChange={this.onChange} className="form-control" required value={this.state.vno} >
									<option value="">Select</option>
									{
										veh.map(function (item) {
											return <option value={item.id }>{item.regno}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Route Code <span className="text-danger">*</span></Label>
								  <Input type="text" name="rcode" required onChange={this.onChange} value={this.state.rcode} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Route Start Place <span className="text-danger">*</span></Label>
								  <Input type="text" name="startplace" required onChange={this.onChange} value={this.state.startplace} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Route Stop Place <span className="text-danger">*</span></Label>
								  <Input type="text" name="stopplace" required onChange={this.onChange} value={this.state.stopplace} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Editroute;


// WEBPACK FOOTER //
// ./src/transport/Transroute/Editroute.js